const SearchLoadingIndicator = function (props) {
  return (
    <div className="search-loading-indicator">
      <img src={SearchLoadingIndicator.LOADING_ICON} />
    </div>
  );
};

SearchLoadingIndicator.LOADING_ICON = '/images/search_loading.gif';

export default SearchLoadingIndicator;
